<template>
  <div>
    <div>
      <router-link to="/orders"
        style="font-size:14px;width:30%;text-decoration: none;line-height:30px;color:#98c14b;display:flex">
        <p>
          <a-icon type="double-left" />
        </p>
        <p>Go Back To Sales Orders</p>

      </router-link>

    </div>
    <div class="actions">
      <h3 style="font-size:28px;line-height:45px">Back Order Campaign</h3>
      <!-- <h3 style="font-size:28px;">Status: <span style="color:#418a49;">{{campaign.statusLabel}}</span></h3> -->
    </div>

    <!-- <div>
				<a-row>
					<a-col style="height: 100%" :span="12">
							<div>
                  <a-col :span="23" style="height:410px; background:#fff;border-radius: 6px;">
                      
                  <div class="wrapper">
                      <div class="container">
                        <a-spin :spinning="spinnerLoader">
                          <line-chart :chartData="chartdata" :chartOptions="options"></line-chart>
                        </a-spin>
                      </div>
                        
                    </div>
                  </a-col>
							</div>
					</a-col>
					<a-col style="background:#ffffff;float: right;border-radius: 6px;" :span="12">
							<div style="padding: 31px;border-radius: 6px;">
									<p style="font-size: 17px;">Top 10 Pre-Orderd Products:</p>
									<br/>
									
									<div style="display:flex;justify-content:space-between;">
											<p>Product</p>
										
											<p>Revenue(Ksh)</p>
										
                      <p>Profit(Ksh)</p>
									</div>
							</div>
  
              <div
                style="padding: 34px;margin-top: -51px;"
                class="demo-infinite-container"
                :infinite-scroll-distance="10"
              >
                <a-list :data-source="topProductdata" :loading="listLoading">
                  <a-list-item slot="renderItem" slot-scope="item">
                    <div class="container1" style="color:#418a49">{{ item.productName }}</div>
                    
                    <div class="container2">{{ item.revenue }}</div>
                
                    <div> {{ item.profitPrice }}</div>
                  </a-list-item>
                
                </a-list>
              </div>
					</a-col>
				</a-row>
			</div> -->
    <div style="margin-top:50px;">
      <div style="display:flex;justify-content: space-between;">
        <!-- <p>Breakdown:</p> -->
        <div style="font-size:20px">
          <p>Pre-Orders</p>
        </div>
        <div style="display:flex;justify-content: flex-end">
          <a-button @click="showViewCampaign"
            style="height:38px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;"
            icon="notification">
            View Campaign
          </a-button>
          <a-button :loading="exportLoading" @click="exportExcell"
            style="height:38px; border-raduis:5px;margin-right:10px; background: #418a49; color:#fff;" icon="export">
            Export
          </a-button>
          <a-dropdown>
            <a-menu slot="overlay">
              <a-menu-item @click="showAggregateOrder" key="1">Product</a-menu-item>
              <a-menu-item @click="showPurchaseOrder" key="2">Purchased Orders</a-menu-item>
              <a-menu-item @click="showWaybills" key="3"> Waybill </a-menu-item>
            </a-menu>
            <a-button style="height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;"
              icon="fork">
              Aggregate <a-icon type="down" />
            </a-button>
          </a-dropdown>

          <!-- <a-button :loading="exportLoading"  style="height:33px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="filter">
                Filter
            </a-button> -->
          <!-- <a-select default-value="All" style="width: 120px">
              <a-select-option value="0">
                All
              </a-select-option>
              <a-select-option value="1">
                Firm
              </a-select-option>
              <a-select-option value="2">
                Soft
              </a-select-option>
              <a-select-option value="3">
                Cancelled
              </a-select-option>
            </a-select> -->

        </div>


      </div>
      <div style="padding-bottom:30px">
        <a-table :columns="columns" :data-source="tableData" :loading="tableLoading" :pagination="pagination"
          @change="handleTableChange" class="saleTable">

          <template slot="action" slot-scope="">
            <a-tooltip>
              <template slot="title">
                More Details?
              </template>
              <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
              <a style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a>
            </a-tooltip>
          </template>
          <template slot="status" slot-scope='data'>
            <div
              style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px"
              v-if="data === 0">
              <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
              <p style="font-size:12px;color:#ffb102;"> Pending </p>
            </div>
            <div
              style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px"
              v-if="data === 1">
              <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
              <p style="font-size:12px;color:rgb(23 140 20);"> Live </p>
            </div>


            <div
              style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px"
              v-if="data === 2">
              <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
              <p style="font-size:12px;color:#41c4fd;"> Completed</p>
            </div>
          </template>

        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash';
const columns = [

  {
    title: 'Date Ordered',
    dataIndex: 'orderedAt',
    key: "orderedAt"
    // width: 200,
  },
  {
    title: 'Retailer Name',
    dataIndex: 'retailerName',
    key: 'retailerName',
    // width: 150,
  },
  {
    title: 'Origination',
    key: 'distributionCenter',
    dataIndex: 'distributionCenter',
  },
  {
    title: 'Product Name',
    dataIndex: 'brandName',
    key: "brandName"
    //  width: 150,
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: "quantity"
    // width: 150,
  },
  {
    title: 'Order Value(Ksh)',
    key: 'orderValue',
    dataIndex: 'orderValue',
  },

  // {
  // 	title: 'Status',
  // 	key: 'status',
  //   dataIndex: 'status',
  //   scopedSlots: { customRender: 'status' }
  // },

  // {
  // 	title: 'Action',
  // 	key: 'action',
  // 	dataIndex: 'action',
  // 	scopedSlots: { customRender: 'action' }
  // },
];

import infiniteScroll from 'vue-infinite-scroll';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import { mapActions, mapGetters } from 'vuex';
import XLSX from "xlsx";
import moment from 'moment';
// import LineChart from './common/LineChart'

export default {

  name: "ViewOrders",
  directives: { infiniteScroll },
  components: {
    // LineChart
  },
  data() {
    return {
      data: [],
      barchartData: null,
      topProductdata: [],
      listLoading: false,
      spinnerLoader: false,
      columns,
      tableData: [],
      tableLoading: false,
      salesReport: {},
      dateFormat: 'YYYY-MM-DD',
      startDate: '',
      endDate: '',
      searchText: '',
      campaign: {},
      pagination: {
        pageSize: 20
      },
      params: {
        page: -1,
        perPage: -1,
        searchBy: {},
        sortBy: {}
      },
      exportLoading: false,
      chartdata: null,
      options: null

    };
  },
  computed: {
    ...mapGetters(['getOrder']),

    displayInvoiceId() {
      return this.campaign.id
    },
    displaySalesAmount() {
      return this.salesReport.totalSales ? parseFloat(this.salesReport.totalSales).toFixed(2) : 'N/A'
    },
    displayProfitsAmount() {
      return this.salesReport.totalProfit ? parseFloat(this.salesReport.totalProfit).toFixed(2) : 'N/A'
    },
    displayCostAmount() {
      return this.salesReport.totalCostPrice ? parseFloat(this.salesReport.totalCostPrice).toFixed(2) : 'N/A'
    },
    showAggregate() {
      return this.campaign.statusLabel === "Completed" ? true : false
    }
  },
  methods: {
    ...mapActions(['getPreOrdersProductsAsync', 'setOrderInfo', 'getPreOrderCampaigns', 'getSummaryPreOrderProduct', 'setSaleTransactionInfo']),

    showAggregateOrder() {
      this.$router.push('/aggregate-order').catch(() => { });
    },
    showPurchaseOrder() {
      this.$router.push('/purchase-order').catch(() => { });
    },
    showViewCampaign() {
      this.$router.push('/view-campaigns').catch(() => { });
    },
    showWaybills() {
      this.$router.push('/waybills').catch(() => { });
    },
    handleTableChange(pagination) {
      this.tableLoading = true
      // console.log("pagination in change | ", pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.params.page = pagination.current;
      this.params.perPage = pagination.pageSize;
      this.params.searchBy = {
        preorderCampaignId: this.campaign.id
      }

      this.getPreOrdersProducts(this.params);
    },
    getSalesReport(reports) {
      // console.log("reports | ", reports)
      let labels = reports.map(report => moment(report.dailyDate).format("DD-MMM"))
      let dataSets = reports.map(report => report.revenue)
      this.chartdata = {
        labels: labels.length > 0 ? labels : ["No Data"],
        datasets: [
          {
            label: 'Sales Report For the Last 7 Days',
            borderColor: '#418a49',
            data: dataSets
          }
        ],
      }
      this.options = {
        responsive: true,
        maintainAspectRatio: false
      }

    },
    showSuccessAlert(message) {
      this.$notification['success']({
        message: message,
      });
    },
    showErrorAlert(message) {
      this.$notification['error']({
        message: message
      });
    },
    exportExcell() {

      this.exportLoading = true
      const dataToExport = [
        [
          "Date Ordered",
          "Product Name",
          "Retailer ID",
          "Retailer Name",
          "Origination",
          "Quantity",
          "Order Value",

        ],
      ];

      this.exportLoading = false;

      this.tableData.forEach((v) => {
        dataToExport.push([
          v.orderedAt,
          v.brandName,
          v.action.retailCentreId,
          v.retailerName,
          v.distributionCenter,
          v.quantity,
          v.orderValue,

        ]);
      });

      let wb = XLSX.utils.book_new();
      let ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(wb, `Export-Campaign-Orders-Report-${moment().format('DD-MM-YYYY')}.xlsx`);
      this.exportLoading = false;
      this.showSuccessAlert("Data Successfully Exported")
    },
    getPreOrdersProducts(request_data) {
      this.tableLoading = true;
      this.getPreOrdersProductsAsync(request_data).then(response => {
        this.tableLoading = false;
        // console.log('response in sales | ', response)
        if (response.status === 200) {
          const pagination = { ...this.pagination };
          pagination.total = response.data.totalRecords;
          let results = response.data.data;
          // console.log('response in results | ', results)
          this.tableData = results.map(product => ({
            key: product.id,
            brandName: product.brandName,
            quantity: product.quantity,
            orderValue: product.orderValue ? product.orderValue.toLocaleString(undefined, { minimumFractionDigits: 2 }) : "N/A",
            distributionCenter: product.distributionCentreName,
            retailerName: product.retailCentreName,
            status: product.status,
            orderedAt: moment(product.orderedAt).format("DD-MMM-YYYY"),
            action: product
          }))
          this.pagination = pagination;
        } else {
          this.tableLoading = false;
          console.log('Error | ', response)
        }
      },
        error => {
          this.tableLoading = false;
          console.log('Error | ', error)
        })
    },
    loadPreOrdersProducts() {
      this.params.searchBy = {
        preorderCampaignId: this.campaign.id
      }
      this.getPreOrdersProducts(this.params)
    },

  },
  created() {
    if (this.getOrder) {
      this.campaign = this.getOrder
    }

    if (this.getPreOrderCampaigns) {
      this.tableLoading = true
      this.getPreOrderCampaigns().then(response => {
        this.tableLoading = false;
        if (response.status === 200) {
          this.setOrderInfo(response.data.data[0]) // Pick the latest campaign
          this.loadPreOrdersProducts();
        } else {
          // console.log("Error | ", response)
        }
      },
        error => {
          console.log("error | ", error)
        })

    }

    // if(this.getSummaryPreOrderProduct){
    //   this.spinnerLoader = true;
    //   this.listLoading = true;
    //     let request_data = {
    //       topProductData : {
    //         page: 1,
    //         perPage: 10,
    //         searchBy: {},
    //         sortBy: {},
    //         preorderCampaignId:this.campaign.id
    //       },
    //       barSalesData: {
    //         startDate: moment().subtract(7,'d').format('YYYY-MM-DD'),
    //         endDate:   moment().add(1, 'd').format('YYYY-MM-DD'),
    //         preorderCampaignId: this.campaign.id,
    //         searchBy: {},
    //         sortBy: {}
    //       }
    //     }
    //     // console.log('response in request_data | ', request_data.barSalesData)
    // 		this.getSummaryPreOrderProduct(request_data).then(response => {
    //         this.listLoading = false;
    //         this.spinnerLoader = false;
    // 				// console.log('response in salesToProduct | ', response[0].data.data)
    // 				if(response.length > 0){
    //             let topProducts = response[0].data.data;
    //             let salesProducts = response[1].data.data;

    //             let topProductsList = topProducts.map(product =>({
    //               productName: product.brandName ? product.brandName : "N/A",
    //               revenue: product.revenue ? parseFloat(product.revenue) : 0.00 ,
    //               profitPrice: product.profit ? parseFloat(product.profit) : 0.00
    //             }));

    //             this.topProductdata = _.orderBy(topProductsList, ['revenue'],['desc']); 
    //             this.getSalesReport(salesProducts);

    // 				}else{
    //             this.listLoading = false;
    //             this.spinnerLoader = false;
    // 						console.log('Error | ', response)
    // 				}

    // 				},
    // 				error => {
    //             this.listLoading = false;
    //             this.spinnerLoader = false;
    // 						console.log('Error | ', error)
    // 				})
    // }
  }
}
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

a {
  text-decoration: none;
}

.saleTable>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.saleTable>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.saleTable>>>.ant-pagination-item-active a {
  color: #fff;
}

.saleTable>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}

.wrapper {
  margin: 0 auto;
  max-height: 400px !important;
  max-width: 400px !important;
}

.center-screen>>>.ant-statistic-title {
  font-size: 20px;
}

.container1 {
  width: 200px;
  padding: 2px 5px;

  /* BOTH of the following are required for text-overflow */
  white-space: nowrap;
  overflow: hidden;
  white-space: initial;
  padding-bottom: 20px;
}

.container2 {
  width: 200px;
  padding: 2px 5px;

  /* BOTH of the following are required for text-overflow */
  white-space: nowrap;
  overflow: hidden;
  white-space: initial;
  padding-bottom: 20px;
}

.demo-infinite-container {
  border-radius: 4px;
  overflow: auto;
  padding: 8px 24px;
  height: 300px;
}

.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
</style>